var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "timer" }, [
    _c("p", [_vm._v("Cart available for...")]),
    _vm._v(" "),
    _c("strong", { staticClass: "countdown" }, [_vm._v(_vm._s(_vm.remaining))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }